/** What the person who asked sees in place of the agent who answered: support is one team, not named staff. */
export const SUPPORT_NAME = 'MedicAI Support';
const SUPPORT_PRINCIPAL = 'medicai-support';

type Sender = { principalId: string; name: string; avatar?: string };

/** Every message not from them shown as from MedicAI Support, with no photo, as one sender so answers run together. */
export function supportSeen<T extends { sender: Sender | null }>(messages: T[], me: string | null): T[] {
  return messages.map((m) => (m.sender && m.sender.principalId !== me
    ? { ...m, sender: { principalId: SUPPORT_PRINCIPAL, name: SUPPORT_NAME } }
    : m));
}

/** "MedicAI Support is typing…", once, whichever agents are. */
export function supportTypists(names: string[]): string[] {
  return names.length ? [SUPPORT_NAME] : [];
}
